import { forwardRef, type Ref, type ReactNode } from 'react';
import { ActionIcon, type ActionIconProps } from '../ActionIcon/ActionIcon.js';

export interface CloseButtonProps extends Omit<ActionIconProps, 'children'> {
  iconSize?: number;
  label?: string;
}

/** Standard ✕ icon button used to close dialogs, drawers, alerts. */
export const CloseButton = forwardRef(function CloseButton(
  { iconSize = 14, label = 'Close', ...rest }: CloseButtonProps,
  ref: Ref<HTMLButtonElement>
): ReactNode {
  return (
    <ActionIcon ref={ref} aria-label={label} {...rest}>
      <svg width={iconSize} height={iconSize} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
        <path d="M2 2 L12 12 M12 2 L2 12" />
      </svg>
    </ActionIcon>
  );
});
